import { isSuperAdminProfileType, ProfileType } from '@/features/currentUser/constants'

export function decideRedirectionPointByRole(profileType) {
  let path = ''

  if (isSuperAdminProfileType(profileType)) {
    path = '/super-admin'
    console.log('decideRedirectionPointByRole ->', path, profileType)
    return path
  }

  switch (profileType) {
    case ProfileType.OrgAdmin:
    case ProfileType.OrgUser:
    case ProfileType.OrgAdminTrial:
      path = '/auth/club-selector'
      // path = '/org-view' // TODO @ozer we don't have this path now
      break
    case ProfileType.MemberAdminTrial:
    case ProfileType.MemberAdmin:
      path = '/auth/club-selector'
      break
    case ProfileType.MemberUser:
      path = '/auth/club-selector' // TODO @ozer, what should be / ??
      break
    case ProfileType.RegistrationWaiting:
      path = '/club-register'
      break
    default:
      path = '/__unknown__'
  }

  console.log('decideRedirectionPointByRole ->', path, profileType)

  return path
}
